import React from 'react';
import TitleMain from '../common/titleMain';
import RankingTable from '../common/tables/rankingTable';
import BehaviorIndicatorsBlock from '../common/behavior/behaviorIndicatorsBlock';

const Detail = props => {
  return (
    <section className="container-detail module-table top">
      <div className="left-col">
        <section className="operation-ranking">
          <table className="table-header">
            <thead>
              <tr>
                <th className="ranking-table-th ranking-th center">
                  {props.language.detail_behavior.table.ranking}
                </th>
                <th className="ranking-table-th info-th">
                  {props.language.detail_behavior.table.driverName}
                </th>
                <th className="ranking-table-th value-th">
                  <a className="noLink helpsortth">
                    {props.language.detail_behavior.table.behaviorGrade}
                    <div className="modal-indicators-info left">
                      <a className="green">
                        <i className="fas fa-question-circle" />
                        <div>
                          <p>{props.language.summary.behaviour.indicatorHelp1Driver}</p>
                          <p>{props.language.summary.behaviour.indicatorHelp2Driver}</p>
                          <p>
                            <span className="green">
                            {props.language.summary.graphTooltip.OUTOFRISK + ": "}
                            </span>
                            {props.language.summary.behaviour.between + " " + props.graphColorRange.outOfRisk[0] + " " + props.language.summary.behaviour.to + " 100"}
                          </p>
                          <p>
                            <span className="yellow">
                            {props.language.summary.graphTooltip.MIDDLERISK + ": "}
                            </span>
                            {props.language.summary.behaviour.between + " " + (props.graphColorRange.middleRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + props.graphColorRange.middleRisk[1]}
                          </p>
                          <p>
                            <span className="red">
                            {props.language.summary.graphTooltip.HIGHRISK + ": "}
                            </span>
                            {props.language.summary.behaviour.between + " " + (props.graphColorRange.higherRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + (props.graphColorRange.higherRisk[1])}
                          </p>
                        </div>
                      </a>
                    </div>
                  </a>
                </th>
              </tr>
            </thead>
          </table>
          {props.datos.driverRanking.length > 0 && (
            <RankingTable
              language={props.language}
              link={props.link}
              data={props.datos.driverRanking}
              nameColumn={'driverName'}
              kpiColumn={'behaviorGrade'}
              graphColorRange={props.graphColorRange}
              filter={props.filter}
            />
          )}
        </section>
      </div>
      <div className="right-col">
        <section className="operation-indicators">
          <TitleMain
            className={"second"}
            title={props.language.detail_behavior.title.mainIndicators}
            info={{
              text: props.language.detail_behavior.help.mainIndicators
            }}
          />
          {props.datos.indicatorSummaryList.length > 0 && props.behaviorConfig && (
            <BehaviorIndicatorsBlock
              data={{
                behaviorGrade: props.datos.behaviorGrade,
                indicators: props.datos.indicatorSummaryList
              }}
              config={props.behaviorConfig.indicators}
              graphColorRange={props.graphColorRange}
              removeChart={true}
            />
          )}
        </section>
        <section className="operation-empty" />
      </div>
    </section>
  );
};
export default Detail;



// WEBPACK FOOTER //
// ./source/client/components/detail_behavior/detail.jsx